{
    "account": "Účet",
    "add_bookmark": "Přidat zprávu do záložek",
    "add_date": "Zadat datum",
    "ago": "před {{duration}}",
    "api_key": "API klíč",
    "are_you_sure": "Jste si opravdu jisti?",
    "ask_delete_message": "Opravdu chcete smazat tuto zprávu?",
    "audio_not_ready": "",
    "bookmark_added": "Zpráva přidána do záložek!",
    "bookmark_removed": "Zpráva odstraněna ze záložek!",
    "bookmarks": "záložky",
    "cancel_write": "Opravdu chcete ukončit psaní nové zprávy?",
    "cancel": "Zrušit",
    "changed_group_name": "změnili jméno skupiny",
    "confirm_password_placeholder": "potvrdit heslo",
    "connect": "Připojení",
    "create_a_group": "Vytvořit skupinu",
    "create_the_group": "Vytvořit tuto skupinu",
    "daily": "Denní",
    "default_group": "Výchozí skupina",
    "delete": "Smazat",
    "destroy_account_explain": "Smazání účtu nelze vrátit zpět. Buďte si opravdu jisti.",
    "destroy_account": "Smazat účet",
    "edit": "Upravit",
    "email": "E-mail",
    "email_input": "Vyplňte sem svůj e-mail",
    "empty_message": "Prázdnou zprávu nelze odeslat!",
    "error": "Došlo k chybě",
    "error_new_message": "Došlo k chybě během odesílání zprávy.",
    "error_upload": "Došlo k chybě během nahrávání",
    "forgot_password": "Zapoměli jste své heslo?",
    "group_left": "Opustili jste tuto skupinu!",
    "group_share_choice": "Do které skupiny chcete poslat tuto zprávu?",
    "groups": "Skupiny",
    "group_updated": "Skupina byla aktualizována!",
    "has_commented_on": "komentovali v",
    "has_joined": "vstoupili",
    "has_left": "opustili",
    "has_posted_in": "zveřejnili v",
    "hourly": "Hodinová",
    "in": "v",
    "Invalid login/password": "Neplatný login a/nebo heslo",
    "invitation_link": "Odkaz s pozvánkou",
    "invitation_welcome": "Vítejte na Zusam! Před vstupem do skupiny se přihlašte.",
    "just_now": "Právě teď",
    "lang": "jazyk",
    "login_input": "Vybrat login",
    "login": "Login",
    "login_placeholder": "e-mail",
    "logout": "Odhlásit",
    "mark_all_as_read": "označit vše jako přečtené",
    "monthly": "Měsíční",
    "multiple_photos_upload": "Došlo k chybě. Zkuste nahrát obrázky jeden po druhém (toto se občas v některých prohlížečích stane).",
    "name_input": "Vybrat jméno",
    "name": "Jméno",
    "new_password_placeholder": "nové heslo",
    "next_coms": "Shlédnout další komentáře",
    "none": "Žádná",
    "notification_emails": "E-mailová upozornění",
    "notification_emails_stopped": "E-mailová upozornění zastavena!",
    "notifications": "upozornění",
    "parent_message": "Nadřazená zpráva",
    "password": "Heslo",
    "password_input": "Vyplňte sem nové heslo",
    "password_placeholder": "heslo",
    "password_reset_mail_sent": "E-mail pro obnovu hesla byl odeslán!",
    "passwords_dont_match": "Hesla se neshodují",
    "previous_coms": "Shlédnout předchozí komentáře",
    "public_link": "veřejný odkaz",
    "publish_in_group": "zveřejnit ve skupině",
    "quit_group": "Opustit skupinu",
    "remove_bookmark": "Smazat zprávu ze záložek",
    "replies_one": "{{count}} odpověď",
    "replies_other": "{{count}} odpovědí",
    "reply": "odpověď",
    "reset_api_key": "Resetovat API klíč (budete odpojeni)",
    "reset_invitation_link": "Resetovat odkaz s pozvánkou",
    "reset_password_title": "Resetovat heslo",
    "save_changes": "Uložit změny",
    "search_in_group": "hledat ve skupině",
    "search_without_result": "Hledání nevrátilo žadné odpovídající zprávy.",
    "settings": "Nastavení",
    "settings_updated": "Nastavení byla aktualizována",
    "share_message": "sdílet zprávu",
    "signup": "Založit účet",
    "submit": "Odeslat",
    "text_placeholder": "Zde napište svou zprávu",
    "the_message_from": "zprávu od",
    "title_placeholder": "Nadpis zprávy (volitelně)",
    "to": "na",
    "upload_audio": "",
    "upload_image": "Nahrát fotky",
    "upload_music": "Nahrát hudbu",
    "upload_pdf": "Nahrát PDF",
    "upload_video": "Nahrát video",
    "User not found": "Uživatel nenalezen",
    "users": "uživatelé",
    "video_not_ready": "Video ještě není připraveno.",
    "weekly": "Týdenní"
}
